import { Button } from "@newsela/angelou";
import {
  stateContainerCss,
  errorIconCss,
  errorTitleCss,
  stateSubtitleCss,
  actionButtonCss,
} from "./LessonPlannerErrorState.style";

interface LessonPlannerErrorStateProps {
  onTryAgain: () => void;
}

const LessonPlannerErrorState = ({
  onTryAgain,
}: LessonPlannerErrorStateProps) => {
  return (
    <div css={stateContainerCss}>
      <div css={errorIconCss}>
        <img
          src="/images/icon/failed_umbrella.svg"
          alt="Error - Umbrella icon"
          width="112"
          height="112"
        />
      </div>
      <div css={errorTitleCss}>Oh no! Something went wrong.</div>
      <div css={stateSubtitleCss}>Please try again.</div>
      <Button
        flavor={Button.flavors.tertiary}
        onClick={onTryAgain}
        __cssFor={actionButtonCss}
      >
        Try again
      </Button>
    </div>
  );
};

export default LessonPlannerErrorState;
